import React from "react";
import {EducationComponent} from "./extends/education";
import {SurveyButtonComponent, SurveyComponent} from "./extends/survey";
import {PledgeButtonComponent} from "./extends/pledge";
import {TermsComponent} from "../../component/visit-application/extends/terms";

export function VisitorHistoryViewComponent({visitorInfo}) {

    return visitorInfo!==undefined && (
        <VisitorHistoryTableComponent>
            {
                <>
                    <tr className="nv_view_nexttable">
                        <td>{visitorInfo.createDateToString}</td>
                        <td>{visitorInfo.name}</td>
                        <td className="m_skip">{visitorInfo.visitorApplicationInfo.hostInfo.team}</td>
                        <td className="m_skip">{visitorInfo.visitorApplicationInfo.hostInfo.name}</td>
                        <td className="m_skip">{`${visitorInfo.visitorApplicationInfo.startDate}~${visitorInfo.visitorApplicationInfo.endDate}`}</td>
                        <td className="m_skip">{`${visitorInfo.visitorApplicationInfo.startTime}시~${visitorInfo.visitorApplicationInfo.endTime}시`}</td>
                        <td>{`${visitorInfo.visitorStatus}`}</td>
                        <td className="m_skip">
                            {
                                visitorInfo.visitorTermsInfos.length > 0
                                    ? '동의완료'
                                    : '미완료'
                            }
                        </td>
                        {/*문진표 삭제 요청으로 주석처리*/}
                        {/*<td className="m_skip">
                            {
                                visitorInfo.visitorSurveyInfo != null
                                    ? '작성완료'
                                    : '미완료'
                            }
                        </td>*/}
                        <td>
                            {
                                visitorInfo.visitorEducationInfos.length > 0
                                    ? '교육완료'
                                    : '미완료'
                            }
                        </td>
                    </tr>
                    <tr className="pc_skip tpc_skip">
                        <td colSpan={10} className="nv_hidden_table_area">
                            <table className="nv_hidden_table" style={{width: '100%'}}>
                                <colgroup>
                                    <col style={{width: '13%'}} />
                                    <col style={{width: '20%'}} />
                                    <col style={{width: '13%'}} />
                                    <col style={{width: '20%'}} />
                                    <col style={{width: '13%'}} />
                                    <col style={{width: '20%'}} />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th scope="col">방문부서</th>
                                        <td>{visitorInfo.visitorApplicationInfo.hostInfo.team}</td>
                                        <th scope="col">접견인</th>
                                        <td>{visitorInfo.visitorApplicationInfo.hostInfo.name}</td>
                                        <th scope="col">방문기간</th>
                                        <td>{`${visitorInfo.visitorApplicationInfo.startDate}~${visitorInfo.visitorApplicationInfo.endDate}`}</td>
                                    </tr>
                                    <tr>
                                        
                                        
                                        
                                    </tr>

                                    <tr>
                                        <th scope="col">약관 및 서약서</th>
                                        <td>
                                            {
                                                visitorInfo.visitorTermsInfos.length > 0
                                                    ? '동의완료'
                                                    : '미완료'
                                            }
                                        </td>
                                        {/*문진표 삭제 요청으로 인해 주석처리*/}
                                        {/*<th scope="col">문진표</th>
                                        <td>
                                            {
                                                visitorInfo.visitorSurveyInfo != null
                                                    ? '작성완료'
                                                    : '미완료'
                                            }
                                        </td>*/}
                                        <th scope="col">방문시간</th>
                                        <td>{`${visitorInfo.visitorApplicationInfo.startTime}시~${visitorInfo.visitorApplicationInfo.endTime}시`}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </>
            }
        </VisitorHistoryTableComponent>
    )
}

export function VisitorHistoryActionComponent({visitorInfo, setVisitorInfo}) {

    function surveyCompleteHandler(surveyInfos) {
        setVisitorInfo({
            ...visitorInfo, survey : true
        })
    }

    function educationCompleteHandler() {
        setVisitorInfo({
            ...visitorInfo, education : true
        })
    }

    function pledgeCompleteHandler(type) {
        switch (type) {
            case 0 :
                setVisitorInfo({
                    ...visitorInfo, visitorExtendsInfo : {
                        ...visitorInfo.visitorExtendsInfo, privacy : true
                    }
                })
                break;
            case 1 :
                setVisitorInfo({
                    ...visitorInfo, visitorExtendsInfo : {
                        ...visitorInfo.visitorExtendsInfo, service : true
                    }
                })
                break;
            case 2 :
                setVisitorInfo({
                    ...visitorInfo, visitorExtendsInfo : {
                        ...visitorInfo.visitorExtendsInfo, security : true
                    }
                })
                break;
        }
    }

    return visitorInfo!==undefined && (
        <VisitorHistoryTableComponent>
            {
                <>
                    <tr>
                        <td>{visitorInfo.createDateToString}</td>
                        <td>{visitorInfo.name}</td>
                        <td className="m_skip">{visitorInfo.visitorApplicationInfo.hostInfo.team}</td>
                        <td className="m_skip">{visitorInfo.visitorApplicationInfo.hostInfo.name}</td>
                        <td className="m_skip">{`${visitorInfo.visitorApplicationInfo.startDate}~${visitorInfo.visitorApplicationInfo.endDate}`}</td>
                        <td className="m_skip">{`${visitorInfo.visitorApplicationInfo.startTime}시~${visitorInfo.visitorApplicationInfo.endTime}시`}</td>
                        <td>{`${visitorInfo.visitorStatus}`}</td>
                        <td className="m_skip">
                            {
                                // <TermsComponent></TermsComponent>
                                    // visitorInfo={visitorInfo}
                                    // pledgeCompleteHandler={pledgeCompleteHandler} />
                            }
                        </td>
                        {/*<td>*/}
                            {/*{*/}
                            {/*    (visitorInfo.visitorExtendsInfo.privacy &&*/}
                            {/*    visitorInfo.visitorExtendsInfo.service &&*/}
                            {/*    visitorInfo.visitorExtendsInfo.security)*/}
                            {/*        ? '동의완료' :*/}
                            {/*            <PledgeButtonComponent*/}
                            {/*                visitorInfo={visitorInfo}*/}
                            {/*                pledgeCompleteHandler={pledgeCompleteHandler} />*/}
                            {/*}*/}
                        {/*</td>*/}
                        {/*문진표 삭제요청으로 인한 주석처리*/}
                       {/* <td className="m_skip">
                            {
                                visitorInfo.visitorSurveyInfos.length > 0
                                    ? '작성완료'
                                    : <SurveyComponent
                                        visitorInfo={visitorInfo}
                                        surveyCompleteHandler={surveyCompleteHandler}/>
                            }
                        </td>*/}
                        <td>
                            {
                                visitorInfo.education
                                    ? '교육완료'
                                    : <EducationComponent visitorInfo={visitorInfo} educationCompleteHandler={educationCompleteHandler}/>
                            }
                        </td>
                    </tr>
                    <tr className="pc_skip tpc_skip">
                        <td colSpan={10}>
                            <table style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <th scope="row">방문부서</th>
                                        <th scope="row">접견인</th>
                                        <th scope="row" colSpan={2}>방문기간</th>
                                    </tr>
                                    <tr>
                                        <td>{visitorInfo.visitorApplicationInfo.hostInfo.team}</td>
                                        <td>{visitorInfo.visitorApplicationInfo.hostInfo.name}</td>
                                        <td colSpan={2}>{`${visitorInfo.visitorApplicationInfo.startDate}~${visitorInfo.visitorApplicationInfo.endDate}`}</td>
                                    </tr>

                                    <tr>
                                        <th scope="row">약관 및 서약서</th>
                                        {/*문진표 삭제 요청으로 주석처리*/}
                                        {/*<th scope="row">문진표</th>*/}
                                        <th scope="row" colSpan={2}>방문시간</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            {
                                                visitorInfo.visitorTermsInfos.length > 0
                                                    ? '동의완료'
                                                    : '미완료'
                                            }
                                        </td>
                                        {/*문진표 삭제 요청으로 주석처리*/}
                                        {/*<td>
                                            {
                                                visitorInfo.visitorSurveyInfos.length > 0
                                                    ? '작성완료'
                                                    : '미완료'
                                            }
                                        </td>*/}
                                        <td colSpan={2}>{`${visitorInfo.visitorApplicationInfo.startTime}시~${visitorInfo.visitorApplicationInfo.endTime}시`}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </>
            }
        </VisitorHistoryTableComponent>
    )
}

function VisitorHistoryTableComponent(props) {

    return (
        <table className="nv_table textcenter" id="historyTable">
            <thead>
            <tr>
                <th scope="row">신청일</th>
                <th scope="row">신청자</th>
                <th scope="row" className="m_skip">방문부서</th>
                <th scope="row" className="m_skip">접견인</th>
                <th scope="row" className="m_skip">방문기간</th>
                <th scope="row" className="m_skip">방문시간</th>
                <th scope="row">상태</th>
                <th scope="row" className="m_skip">약관 및 서약서</th>
                {/*문진표 삭제요청으로 주석처리*/}
                {/*<th scope="row" className="m_skip">문진표</th>*/}
                <th scope="row">방문교육</th>
            </tr>
            </thead>
            <tbody>
                {props.children}
            </tbody>
        </table>
    )
}